module.exports = __webpack_public_path__ + "static/media/e.f0164dd2.svg";